import { IComponentOptions } from "angular";
import { MachineTypeIdEditComponentController } from "./controller";

export const vsComponentName = "machineTypeIdEditComponent";

export const machineTypeIdEditComponentOptions: IComponentOptions = {
  controller: MachineTypeIdEditComponentController,
  controllerAs: "machineTypeIdEditComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    typeId: "<",
  },
};
